import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import SimpleDialog from "../../dialogs/SimpleDialog";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {
	addQuarantenaHistory,
	getQuarantenaById,
	getQuarantenaHistory,
	updateQuarantena
} from "../../../../services/QuaranteneServices";
import { Skeleton } from '@mui/material';
import {Button, DialogActions, MenuItem, Paper, Typography} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import moment from "moment";
import {transformDTOtoReadableString} from "../../../gestione/quarantene/detail/HistoryCard";
import {useTheme} from "@mui/material/styles";
import CustomSelect from "../../inputs/CustomSelect";
import Grid from "@mui/material/Grid";
import {useForm} from "react-hook-form";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import CustomMultiText from "../../inputs/CustomMultiText";
import {bigNoteRegisterRequired} from "../../../../utils/RegisterUtils";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AppContext} from "../../../../App";
import {getAccountInfo} from "../../../../utils/GenericUtils";
import CustomDateInput from "../../inputs/CustomDateInput";
import {tipoMonitortaggio} from "../../../../utils/arrays/Generics";

export const QuarantenaDialog = ({idQuarantena, setOpen}) => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	let theme = useTheme();
	const [state, dispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const {control, handleSubmit, errors, register, reset} = useForm({
		mode: "onChange",
	});
	const [isReset, setIsReset] = useState(false);
	const [submit, setSubmit] = useState(false);
	//todo dsabilita monitogìraggio
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateQuarantena({
			...state.quarantena, ...data,
		}, dispatch);
		addQuarantenaHistory({
			...data,
		}, idQuarantena, dispatch);
	}, [idQuarantena, dispatch, state.quarantena])
	
	useEffect(() => {
		getQuarantenaHistory(idQuarantena, dispatch);
		getQuarantenaById(idQuarantena, dispatch)
	}, [idQuarantena, dispatch])
	
	useEffect(() => {
		if (!isReset && !state.loadingGetQuarantena && state.errorGetQuarantena === "") {
			reset(state.quarantena);
			setIsReset(true);
		}
	}, [isReset, state.loadingGetQuarantena, state.errorGetQuarantena, reset, state.quarantena])
	
	useEffect(() => {
		if (submit && !state.loadingUpdateQuarantena && state.errorUpdateQuarantena === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Informazioni aggiornate con successo!", appContext.dispatch);
		} else if (submit && !state.loadingUpdateQuarantena && state.errorUpdateQuarantena !== "") {
			setSubmit(false);
			setOpenSnackbar("error", state.errorUpdateQuarantena, appContext.dispatch);
		}
	}, [submit, state.loadingUpdateQuarantena, state.errorUpdateQuarantena, appContext.dispatch])
	
	return (
		<React.Fragment>
			<SimpleDialog
				maxWidth={"md"}
				open={idQuarantena !== ""}
				handleClose={() => setOpen("")}
				title={"Dettaglio dell'ordinanza n°" + idQuarantena}
				content={
					<React.Fragment>
						{
							state.loadingGetQuarantenaHistory ? <Skeleton/> :
								state.errorGetQuarantenaHistory !== "" ? "Err" :
									state.quarantenaHistory
										.filter(stoElem => !stoElem.lastModify.includes("AUTODUMP"))
										.sort((a, b) => new Date(b.dataModifica) - new Date(a.dataModifica))
										.map((item, index) => {
											return (
												<Paper elevation={0} key={index} id={"paper-storico" + index}
												       style={{
													       backgroundColor: theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800],
													       borderRadius: 24,
													       padding: 16,
													       marginRight: 100,
													       marginTop: 16
												       }}>
													<Typography variant={"subtitle2"} color={"textSecondary"}>
														<b>{item.lastModify}</b> ha scritto in
														data: {moment(item.dataModifica).format("DD/MM/YYYY - HH:mm")}
													</Typography>
													<Typography variant={"subtitle1"}>
														{
															item.note?.includes("DTO") ? transformDTOtoReadableString(item.note) : item.note
														}
													</Typography>
												</Paper>
											)
										})
						}
						{
							state.loadingGetQuarantena ? <Skeleton/> :
								state.errorGetQuarantena !== "" ? "Err.." :
									<React.Fragment>
										<Grid container spacing={3} style={{marginTop: 20}}>
											<Grid item xs={12} sm={6}>
												<CustomSelect
													label={"Stato"}
													control={control}
													defaultValue={"IN CORSO"}
													autoFocus={false}
													rules={{required: true}}
													name={"stato"}
													error={errors["stato"]}
												>
													{["NUOVA", "IN CORSO", "GUARITO", "CONCLUSA"].map((val, key) => {
														return (
															<MenuItem value={val} key={key}>
																{val}
															</MenuItem>
														);
													})}
												</CustomSelect>
											</Grid>
											<Grid item xs={12} sm={6}>
												<CustomSelect
													label={"Tipo di monitoraggio"}
													control={control}
													defaultValue={tipoMonitortaggio[0]}
													autoFocus={false}
													rules={{required: true}}
													name={"tipoMonitoraggio"}
													error={errors["tipoMonitoraggio"]}
												>
													{tipoMonitortaggio.map((val, key) => {
														return (
															<MenuItem value={val} key={key}>
																{val}
															</MenuItem>
														);
													})}
												</CustomSelect>
											</Grid>
											<Grid item xs={12} sm={6}>
												<CustomDateInput
													name={"dataInizio"}
													label={"Data inizio"}
													control={control}
													defaultValue={null}
													rules={{required: true}}
													error={errors["dataInizio"]}
												/>
											</Grid>
											<Grid item xs={12} sm={6}>
												<CustomDateInput
													name={"dataFine"}
													label={"Data fine"}
													control={control}
													defaultValue={null}
													rules={{required: false}}
													error={errors["dataFine"]}
												/>
											</Grid>
											<Grid item xs={12}>
												<CustomMultiText
													inputRef={register(bigNoteRegisterRequired)}
													label={"Note"}
													autoFocus={false}
													name={"note"}
													error={errors["note"]}
													rows={5}
												/>
											</Grid>
										</Grid>
									</React.Fragment>
						}
					</React.Fragment>
				}
				actions={
					<DialogActions>
						<Button size={"small"} variant={"text"} className={classes.roundButton} onClick={() => {
							setOpen("")
						}}>
							<b>Chiudi</b>
						</Button>
						<Button size={"small"} variant={"contained"} color={"primary"} disableElevation
						        disabled={submit || getAccountInfo().roles?.includes("ROLE_SP_301_H")}
						        className={classes.roundButton} onClick={handleSubmit(onSubmit)}>
							<b>Applica modifiche</b>
						</Button>
					</DialogActions>
				}
			/>
		</React.Fragment>
	);
};
